module.exports = __webpack_public_path__ + "img/logo-invoize-no-edas-dark.0b36e35f.png";